import { Reveal } from "@/components/site/Reveal";

const steps = [
  { n: "01", title: "Choose a Method", desc: "Choose your preferred appointment or contact method." },
  { n: "02", title: "Share Your Enquiry", desc: "Share your basic enquiry and consultation preference." },
  { n: "03", title: "Receive Guidance", desc: "Receive appointment guidance from the clinic." },
  { n: "04", title: "Visit the Clinic", desc: "Visit the clinic and follow the confirmed consultation process." },
];

export function PatientJourney() {
  return (
    <section id="journey" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="label">Patient Information</span>
              <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-[#0A192F]">How to Consult</h2>
              <p className="mt-5 text-lg text-[#475569] leading-relaxed">A simple, transparent path from first enquiry to your consultation.</p>
            </Reveal>
            <Reveal delay={0.2} className="mt-8 rounded-[1.5rem] overflow-hidden aspect-[5/4] bg-[#F4F7FA]">
              <img
                src="https://images.unsplash.com/photo-1666886573531-48d2e3c2b684?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Physician guiding a patient through consultation information"
                className="w-full h-full object-cover" loading="lazy"
              />
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="grid sm:grid-cols-2 gap-6" data-testid="patient-journey-steps">
              {steps.map((s, i) => (
                <Reveal key={s.n} delay={(i % 2) * 0.1}>
                  <div className="bg-white p-8 lg:p-9 h-full rounded-2xl border border-[#E6EBF0] hover:border-[#0D9488] transition-colors duration-300">
                    <span className="inline-grid place-items-center w-10 h-10 rounded-full bg-[#F4F7FA] font-mono text-sm text-[#0D9488] font-medium">{s.n}</span>
                    <h3 className="font-display text-xl mt-5 text-[#0B1B2B]">{s.title}</h3>
                    <p className="mt-2 text-[#4A5A6A]">{s.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
